var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon-read-indicator",class:{ read: _vm.read },attrs:{"width":"9","height":"9","viewBox":"0 0 9 9","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"dot",attrs:{"cx":"4.5","cy":"4.5","r":"3.5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }